import { z } from 'zod';

export const primaryType = z
  .string()
  .or(z.number())
  .or(z.boolean())
  .or(z.record(z.string(), z.string().or(z.number()).or(z.boolean())))
  .or(z.array(z.string().or(z.number()).or(z.boolean())));

export const primaryTypeRecord = z.record(z.string(), primaryType);
export const deepPrimaryType = primaryTypeRecord.or(z.record(z.string(), primaryTypeRecord));

export type RevcatOfferingId = z.infer<typeof revcatOfferingId>;
export const revcatOfferingId = z.string();

export const paywallFooterElement = z.object({
  text: z.string(),
  propsOverrides: deepPrimaryType.optional(),
  translationData: z.record(z.string(), z.string()).optional(),
});
export type PaywallFooterElement = z.infer<typeof paywallFooterElement>;

export const stripeConfigItem = z.object({
  matchingProductIds: z.array(z.string()).optional(),
  inAppPriceStringMatch: z.array(z.string()).optional(),
  footerElement: paywallFooterElement.optional(),
  urlQueryParams: z.record(z.string(), z.string()).optional(),
  useWebView: z.boolean().optional(),
  promocode: z.string().optional(),
});
export type StripeConfigItem = z.infer<typeof stripeConfigItem>;

export const stripeSettings = z.object({
  config: z.record(z.string(), stripeConfigItem).optional(),
});
export type StripeSettings = z.infer<typeof stripeSettings>;

export const stripeConfig = z.object({
  webBaseUrl: z.string(),
  config: z.record(z.string(), stripeConfigItem).optional(),
  defaultConfig: stripeConfigItem.optional(),
});
export type StripeConfig = z.infer<typeof stripeConfig>;
